
import { mapState } from "vuex";
export const commonFuc = {
  data() {
    return {
      isMaster: false,
      shopIsMaster: false,
      payInterfacePartyTypes: {
        0: "未知",
        1: "系统",
        4: "银联支付",
        5: "百付宝",
        6: "QQ钱包",
        7: "京东钱包",
        8: "刷卡记账",
        9: "现金记账",
        10: "会员卡支付",
        11: "线下收款",
        12: "支付宝记账",
        13: "微信记账",
        2: "支付宝",
        3: "微信",
        14: "抖音记账",
        15: "美团记账",
        14: "其他平台记账",
      },
      mapCenterInputText: ""
    }
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    isDsType() {
      return this.shopInfo.edcShopType == 14 || this.shopInfo.edcShopType == 2
    }
  },
  watch: {
    shopInfo(val) {
      this.shopIsMaster = this.shopInfo.isMaster;
    },
  },
  created() {
    this.isMaster = localStorage.userType == 101;
    this.shopIsMaster = this.shopInfo.isMaster;
  },
  methods: {
    linkTo(path) {
      this.$router.push({
        path: path
      })
    },
    isLess(target, com, date = "") {
      let comObj = com.split("]");
      if (comObj.length == 2) {
        comObj = new Date(
          `${new Date(+new Date(date) + 24 * 60 * 60 * 1000).pattern(
            "yyyy-MM-dd"
          )} ${comObj[1].trim()}`
        );
      } else {
        comObj = new Date(`${new Date(date).pattern("yyyy-MM-dd")} ${comObj[0].trim()}`);
      }
      return Number(target) <= +comObj;
    },
    formatTime(target, date = "") {
      let targetTime = target.split("]");
      if (targetTime.length == 2) {
        targetTime = new Date(
          `${new Date(+new Date(date) + 24 * 60 * 60 * 1000).pattern(
            "yyyy-MM-dd"
          )} ${targetTime[1].trim()}`
        );
      } else {
        targetTime = new Date(
          `${new Date(date).pattern("yyyy-MM-dd")} ${targetTime[0].trim()}`
        );
      }
      return targetTime;
    },
    showDialogMap() {
      window.open(
        // "https://lbs.amap.com/tools/picker",
        "https://lbs.amap.com/demo/javascript-api/example/map/click-to-get-lnglat",
        "blank"
      );
    },
    mapCenterInputTextBlur(formData) {
      if(this.mapCenterInputText && this.mapCenterInputText.split(/,|，/).length>1) {
        formData.longitude = this.mapCenterInputText.split(/,|，/)[0]
        formData.latitude = this.mapCenterInputText.split(/,|，/)[1]
        formData.lng = this.mapCenterInputText.split(/,|，/)[0]
        formData.lat = this.mapCenterInputText.split(/,|，/)[1]
        formData.lon = this.mapCenterInputText.split(/,|，/)[0]
        formData.lat = this.mapCenterInputText.split(/,|，/)[1]
      }
    }
  }
}
